import {
  getStaffDetail,
  changeCompany,
  getBusinessCount,
  saveExamine,
  getStationStaffList,
  getProblemSiteCount,
  getProblemTypeCount,
  getProcessOrderList,
  getMemberList,
  getMessageLists,
  readMessageInfo,
  updateMessageStatus,
  mySite,
  messageList,
  getServiceTeam,
  getSiteList,
  getMessageListApi,
  getComplaintList,
  getDepartmentList,
  saveManagerMember,
  getManagerMemberList,
  getManagerMemberInfo,
  getCompanyList
} from '@/api/engineeringManager.js'

import { setTokenByKey, setToken, getToken } from '@/utils/auth'
import { Notify } from 'vant'
import { login } from '@/api/staff'
const staffDetailKey = 'engineering-manager_staff-detail'

const setStaffDetail = token => setTokenByKey(token, staffDetailKey)

import { SessionStorage } from '@/utils'
import { getStaffRole } from '@/api/delivery'
const session = new SessionStorage()

const state = {
  token: getToken(),
  staff_detail: '',
  company_list: '',
  current_company: '',
  station_type_id: 2,
  keep_alive_list: [],
  def_staff_role_id: session.get('def_staff_role_id') || '',
  staff_role_list: session.getObject('staff_role_list') || ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_STAFF_DETAIL: (state, staff_detail) => {
    state.staff_detail = staff_detail
    setStaffDetail(JSON.stringify(staff_detail))
  },
  SET_COMPANY_LIST: (state, company_list) => {
    state.company_list = company_list
  },
  SET_CURRENT_COMPANY: (state, current_company) => {
    state.current_company = current_company
  },
  SET_KEEP_ALIVE_LIST: (state, keep_alive_list) => {
    state.keep_alive_list = keep_alive_list
  },
  SET_DEF_STAFF_ROLE_ID: (state, staff_role_id) => {
    session.set('def_staff_role_id', staff_role_id)
    state.def_staff_role_id = staff_role_id
  },
  SET_STAFF_ROLE_LIST: (state, staff_role_list) => {
    session.setObject('staff_role_list', staff_role_list)
    state.staff_role_list = staff_role_list
  }
}

const actions = {
  setToken({ state, commit }, token) {
    commit('SET_TOKEN', token)
  },
  setStaffDetail({ state, commit }, staff_detail) {
    commit('SET_TOKEN', staff_detail)
  },
  addKeepAliveItem({ state, commit }, item) {
    const keep_alive_list = state.keep_alive_list
    const set = new Set(keep_alive_list)
    set.add(item)
    commit('SET_KEEP_ALIVE_LIST', Array.from(set))
  },
  delKeepAliveItem({ state, commit }, item) {
    const keep_alive_list = state.keep_alive_list
    const set = new Set(keep_alive_list)
    set.delete(item)
    commit('SET_KEEP_ALIVE_LIST', Array.from(set))
  },
  clearKeepAliveList({ state, commit }, item) {
    commit('SET_KEEP_ALIVE_LIST', [])
  },
  async login({ state, commit, dispatch }, data) {
    try {
      const res = await login(data)
      const { staff_access_info } = res.data.data
      const token = staff_access_info.token
      dispatch('setToken', token)
      return res.data.data
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('weixin/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      await dispatch('setToken', token)
      return token
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  getStaffRole({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffRole(data).then(response => {
        if (response.data.data.staff_role_List.length) {
          commit('SET_STAFF_ROLE_LIST', response.data.data.staff_role_List)
        }
        if (!state.def_staff_role_id && response.data.data.staff_role_List.length) {
          commit('SET_DEF_STAFF_ROLE_ID', response.data.data.staff_role_List[0].staff_role_id)
        }
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getStaffDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffDetail(data).then(response => {
        commit('SET_STAFF_DETAIL', response.data.data.staff_info)
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 03-切换当前门店
  changeCompany({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      changeCompany(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // PM-01-工程部经理业务工作台
  getBusinessCount({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getBusinessCount(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // PM-02-工程部经理业务数据统计
  getProblemSiteCount(temp, data) {
    return new Promise((resolve, reject) => {
      getProblemSiteCount(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // PM-03-工程部经理问题类型统计
  getProblemTypeCount(temp, data) {
    return new Promise((resolve, reject) => {
      getProblemTypeCount(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-02-硬装流程订单列表
  getProcessOrderList(temp, data) {
    return new Promise((resolve, reject) => {
      getProcessOrderList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // G-1201-工程部通过审核提交
  saveExamine(temp, data) {
    return new Promise((resolve, reject) => {
      saveExamine(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // B-14-获取服务岗位员工列表
  getStationStaffList(temp, data) {
    return new Promise((resolve, reject) => {
      getStationStaffList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // J-01获取外部资源列表
  getMemberList(temp, data) {
    return new Promise((resolve, reject) => {
      getMemberList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // S-01-获取消息列表
  getMessageLists({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMessageLists(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // A-05-我的工地
  mySite(temp, data) {
    return new Promise((resolve, reject) => {
      mySite(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // S-03-读取消息
  readMessageInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      readMessageInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // pm-06-进程播报
  messageList(temp, data) {
    return new Promise((resolve, reject) => {
      messageList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // S-05-更新消息为已读状态
  updateMessageStatus({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      updateMessageStatus(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // pm-07-我的服务团队
  getServiceTeam(temp, data) {
    return new Promise((resolve, reject) => {
      getServiceTeam(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // pm-04-工程部经理-工地管理
  getSiteList(temp, data) {
    return new Promise((resolve, reject) => {
      getSiteList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // F-v2-播报-获取播报列表
  getMessageListApi(temp, data) {
    return new Promise((resolve, reject) => {
      getMessageListApi(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // E-客诉处理-02-获取待处理客诉列表
  getComplaintList(temp, data) {
    return new Promise((resolve, reject) => {
      getComplaintList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 08-获取交付部门列表(new)
  getDepartmentList(temp, data) {
    return new Promise((resolve, reject) => {
      getDepartmentList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // D-02新增编辑项目经理列表(new)
  saveManagerMember(temp, data) {
    return new Promise((resolve, reject) => {
      saveManagerMember(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // D-03获取项目经理列表(new)
  getManagerMemberList(temp, data) {
    return new Promise((resolve, reject) => {
      getManagerMemberList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // D-04获取项目经理详情(new)
  getManagerMemberInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getManagerMemberInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 07-获取交付公司列表(new)
  getCompanyList({ commit }, data) {
    return new Promise((resolve, reject) => {
      getCompanyList(data).then(response => {
        commit('SET_COMPANY_LIST', response.data.data.company_list)
        const current_company = response.data.data.company_list.find(company => company.is_current === '1')
        commit('SET_CURRENT_COMPANY', current_company)
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
